import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Button } from '@lyearn/ui';
import { ButtonProps } from '@lyearn/ui/src/Buttons/Button/types';

import SubmitQuizDialog from '../SubmitQuizDialog';
import useSubmitQuizDialog from './useSubmitQuizDialog';

type SubmitQuizButtonProps = {
  onSubmitQuiz: () => void;
  getUnansweredQuestions: () => number;
  getUnsubmittedQuestionsCount: () => number;
  showConfirmation?: boolean;
  className?: string;
} & Pick<ButtonProps, 'size' | 'shape'>;

const SubmitQuizButton: React.FC<SubmitQuizButtonProps> = (props) => {
  const {
    onSubmitQuiz,
    getUnansweredQuestions,
    getUnsubmittedQuestionsCount,
    showConfirmation,
    className,
    size = 'medium',
    shape,
  } = props;
  const { t } = useTranslation();

  const { showDialog, onClose, onSubmit } = useSubmitQuizDialog({
    getUnansweredQuestions,
    showConfirmation,
    onSubmitQuiz,
  });

  return (
    <>
      <Button
        appearance={getUnsubmittedQuestionsCount() === 0 ? 'primary' : 'secondary'}
        className={className}
        shape={shape}
        size={size}
        onClick={onSubmit}>
        {t('QuizPlayer:SubmitQuiz')}
      </Button>
      {!showDialog ? null : (
        <SubmitQuizDialog
          count={getUnansweredQuestions()}
          dialogType={showDialog.type}
          onClose={onClose}
          onSubmitQuiz={onSubmitQuiz}
        />
      )}
    </>
  );
};

export default SubmitQuizButton;
